// Keep in parity with Fable-App/i18n/index.ts.
export const SUPPORTED_LANGUAGES = {
    en: { code: 'en', name: 'English' }, es: { code: 'es', name: 'Español' }, ru: { code: 'ru', name: 'Русский' },
    fr: { code: 'fr', name: 'Français' }, de: { code: 'de', name: 'Deutsch' }, it: { code: 'it', name: 'Italiano' },
    pt: { code: 'pt', name: 'Português' }, nl: { code: 'nl', name: 'Nederlands' }, pl: { code: 'pl', name: 'Polski' },
    zh: { code: 'zh', name: '中文' }, ja: { code: 'ja', name: '日本語' }, ko: { code: 'ko', name: '한국어' },
    tr: { code: 'tr', name: 'Türkçe' }, ar: { code: 'ar', name: 'العربية' }, hi: { code: 'hi', name: 'हिन्दी' },
    uk: { code: 'uk', name: 'Українська' }, vi: { code: 'vi', name: 'Tiếng Việt' }, bg: { code: 'bg', name: 'Български' },
    cs: { code: 'cs', name: 'Čeština' }, fi: { code: 'fi', name: 'Suomi' }, el: { code: 'el', name: 'Ελληνικά' },
    id: { code: 'id', name: 'Bahasa Indonesia' }, ro: { code: 'ro', name: 'Română' }, th: { code: 'th', name: 'ไทย' },
} as const;
export type LanguageCode = keyof typeof SUPPORTED_LANGUAGES;
export const languageFromPath = (pathname: string): LanguageCode => {
    const code = pathname.split('/').filter(Boolean)[0];
    return Object.prototype.hasOwnProperty.call(SUPPORTED_LANGUAGES, code) ? code as LanguageCode : 'en';
};
export const stripLanguage = (pathname: string) => {
    const parts = pathname.split('/').filter(Boolean);
    if (parts[0] && Object.prototype.hasOwnProperty.call(SUPPORTED_LANGUAGES, parts[0]))
        parts.shift();
    return `/${parts.join('/')}`;
};
